import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';


@Component({

    templateUrl: './app.about.component.html'
})
export class AboutComponent implements OnInit {

    public constructor(private titleService: Title) {
        document.body.style.backgroundImage = 'url("assets/images/Login.jpg")';
        document.body.style.backgroundRepeat = 'no-repeat';
        document.body.style.backgroundSize = 'cover';
		
		
		   
    }

    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

    ngOnInit() {
        this.setTitle('پلنتو | آشنایی با سرویس')
    }

}




// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.about.component.ts